<template>
  <div class="calendar-wrapper">
    <div class="calendar-header">
      <div class="left-ring"></div>
      <div class="right-ring"></div>
      <div
        class="
          month-text
          h-100
          d-flex
          justify-content-center
          align-items-center
        "
      >
        {{ monthText }}
      </div>
    </div>
    <div class="calendar-body d-flex justify-content-center align-items-center">
      <div v-html="dayText"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "calendar-icon",
  props: ["monthText", "dayText"],
};
</script>

<style scoped>
.calendar-wrapper {
  width: 66px;
  height: 66px;
}
.calendar-header {
  background: var(--secondary-color);
  font-family: artifaktElementBold !important;
  position: relative;
  height: 22px;
}
.calendar-body {
  margin-top: -2px;
  height: 48px;
  background: #ffffff;
  border: 1.5px solid #e4e4e4;
  border-radius: 3px;
  font-family: artifaktElementBold !important;
  font-size: 18px;
}
.month-text {
  color: white;
  font-size: 9px;
  padding-top: 2px;
}

.left-ring,
.right-ring {
  background: #ffc21a;
  width: 3px;
  height: 7px;
  position: absolute;
  border-radius: 2px;
  top: -4px;
}

.left-ring {
  left: 7px;
}
.right-ring {
  right: 7px;
}
</style>
